;(function () {

"use strict";

var ModalTemplate = require('./templates/modal.html');

var onKeyDown = function (e) {
  if (e.keyCode === 27) {
    var len = window.App.Modals.length;
    window.App.Modals[len-1].hide();
    return false;
  }
};

var ModalView = Backbone.View.extend({
  className: 'modal',
  initialize: function (opts) {
    opts = opts || {};
    this.content = opts.content;

    this.guid = window.App.guid();
  },

  render: function () {
    var html = _.template(ModalTemplate, {variable: 'data'})({content: this.content});
    this.$el.append(html).hide();
    $('body').append(this.$el);
    return this;
  },

  show: function (cb) {
    if (this.busy) return;

    var self = this;
    
    this.$el.imagesLoaded().always(function () { 
      self.$el.show().addClass('active');
    });

    window.App.Modals = window.App.Modals || [];
    window.App.Modals.push(this);

    if (window.App.Modals.length === 1) {
      $('body').on('keydown.modal', onKeyDown);
    }

    return this;
  },

  hide: function (e, doNotDestroy) {
    if (e) {
      e.preventDefault();
    }

    var cb = function () {
      this.$el.hide();

      if (!doNotDestroy) {
        this.destroy();
      }
    };

    this.$el.removeClass('active');
    _.delay(_.bind(cb, this), 500);

    window.App.Modals.pop();

    if (window.App.Modals.length === 0) {
      $('body').off('keydown.modal');
    }

    return this;
  },

  destroy: function () {
    //$('body').off('keydown.'+this.guid);

    this.undelegateEvents();
    this.$el.removeData().unbind().remove();
    // Remove view from DOM
    this.remove();
    Backbone.View.prototype.remove.call(this);
  },

  events: {
    'click .overlay': "hide",
    'click .close': "hide"
  }

});

module.exports = ModalView;

}());